const _ = require('lodash');
const {
    RALLY_EVENT_DEFAULT_PAGE_SETTINGS,
    CURRENCY_INFO,
    DONATION_PAYMENT_MODE,
} = require('../constants');
const { ABANDONED_DELAY_UNITS } = require('../constants/abandoned');

const assignDefaultValue = (target, propertyPath, defaultValue) => {
    _.set(target, propertyPath, _.get(target, propertyPath, defaultValue));
};

const assignDefaultPageSettingsParameter = (target, propertyPath) => {
    return assignDefaultValue(
        target,
        `pageSettings.${propertyPath}`,
        _.get(RALLY_EVENT_DEFAULT_PAGE_SETTINGS, propertyPath),
    );
};

const getPageSettingsParameter = (pageSettings, propertyPath) => {
    return _.get(
        pageSettings,
        propertyPath,
        _.get(RALLY_EVENT_DEFAULT_PAGE_SETTINGS, propertyPath, null),
    );
};

const calculateNotificationDelay = (delayPeriod, delayType = 'minutes') => {
    switch (delayType) {
        case ABANDONED_DELAY_UNITS.DAYS:
            return delayPeriod * 24 * 3600000;
        case ABANDONED_DELAY_UNITS.HOURS:
            return delayPeriod * 3600000;
        case ABANDONED_DELAY_UNITS.MINUTES:
        default:
            return delayPeriod * 60000;
    }
};

const arrayToQuery = (items, parameterName = 'id') =>
    items && items.length
        ? items
              .reduce((queryItems, value) => {
                  if (value) {
                      queryItems.push(`${parameterName}[]=${value}`);
                  }
                  return queryItems;
              }, [])
              .join('&')
        : '';

/**
 * Joins valid truthy strings, uses ' ' (space) as delimiter by default
 * A config can be passed in optionally as the first argument with custom
 * delimiter
 * @param {object} [config]
 * @param {...string} args
 * @returns {string}
 */
const joinValidStrings = (...args) => {
    // we allow the first argument to optionally be an config object
    // we use the first argument to allow for currying or partial application
    let config = {};
    if (typeof args[0] === 'object') {
        config = args.shift();
    }

    const delimiter = config?.delimiter || ' ';

    return args
        .filter(s => Boolean(s) && typeof s === 'string')
        .join(delimiter)
        .trim();
};

const glueClassName = classes => joinValidStrings(...classes);

const currencySign = currency => {
    return _.get(CURRENCY_INFO, [currency, 'sign']);
};

const currencyLabel = currency => {
    return _.get(CURRENCY_INFO, [currency, 'label'], currency);
};

const getDonationMonths = donation => {
    switch (donation.paymentMode) {
        case DONATION_PAYMENT_MODE.monthly:
        case DONATION_PAYMENT_MODE.unlimitedRecurring:
            return donation.recurringMonths;
        case DONATION_PAYMENT_MODE.installments:
            return donation.installmentMonths;
        default:
            return 1;
    }
};

const roundAmount = amount => Math.round(amount * 100) / 100;
const integerAmount = amount => parseInt(roundAmount(amount), 10) || 0;

const integerAmountBase10 = amount => {
    if (amount < 1000) {
        return parseInt(Math.max(Math.round(amount), 0), 10);
    }

    return parseInt(Math.max(Math.round(amount / 10) * 10, 1), 10);
};

const getSingleDonationAmount = (amount, layerItemsCount = 1) => {
    const singleLayerItemAmount =
        Math.round((amount / Math.max(layerItemsCount, 1)).toFixed(2) * 100) /
        100;

    return singleLayerItemAmount;
};

module.exports = {
    assignDefaultValue,
    assignDefaultPageSettingsParameter,
    getPageSettingsParameter,
    calculateNotificationDelay,
    arrayToQuery,
    joinValidStrings,
    glueClassName,
    currencySign,
    currencyLabel,
    getDonationMonths,
    roundAmount,
    integerAmount,
    integerAmountBase10,
    getSingleDonationAmount,
};
